/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';

import TM21 from './TM21';
import { IGoodReceive } from '@/interfaces/goodReceive';
import TM22 from './TM22';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  gr: IGoodReceive | undefined;
  tms: string[];
}

const PrintModal = ({ open, handleCancel, gr, tms }: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${gr?.code}`,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          {tms.includes('TM24') && <TM21 data={gr} />}
          {tms.includes('TM25') && <TM22 data={gr} />}
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
